/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./constants/main.js");function c(i){const e=[];return i.replace(r.FIELD_REGEX,function(s,t,n,o){e.push(t!==void 0?t:n||o)}),e}exports.fieldList=c;
